import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../components/Modal';
import Input from '../components/Input';

const Passcode = ({ close, onChange, onSubmit, passcode, passcodeError }) => (
  <Modal title="Enter booking code" close={close}>
    <form className="layout layout--flush" onSubmit={onSubmit}>
      <div className="layout__item u-3/4">
        <Input
          type="text"
          placeholder="Enter booking code"
          className="u-mt0"
          required
          value={passcode}
          onChange={onChange}
        />
      </div>
      <div className="layout__item u-1/4">
        <button className="c-btn c-btn--default u-ph-" disabled={!passcode}>Submit</button>
      </div>
    </form>
    {passcodeError && <p className="u-co-red u-mt-"><strong>{passcodeError}</strong></p>}
  </Modal>
);

Passcode.propTypes = {
  close: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  passcode: PropTypes.string,
  passcodeError: PropTypes.string,
};

Passcode.defaultProps = {
  passcode: '',
  passcodeError: '',
};

export default Passcode;



// WEBPACK FOOTER //
// ./src/app/passcode/Passcode.jsx